import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { OrdersTable } from './OrdersTable';

const OrdersPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle>{t('common.orders')}</PageTitle>
      <OrdersTable />
    </>
  );
};

export default OrdersPage;
